import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Toggle from '../../../../components/Toggle';
import { addNFEmailTracking, removeNFEmailTracking } from '../../../../redux/tracking';

import './styles.css';

const propTypes = {
  dispatch: PropTypes.func,
  className: PropTypes.string,
  nfData: PropTypes.shape({
    id: PropTypes.number,
    nf: PropTypes.string,
    nfGroup: PropTypes.string,
    cnpjEmit: PropTypes.string,
    cnpjDest: PropTypes.string,
    following: PropTypes.bool,
  }),
  label: PropTypes.string,
  vertical: PropTypes.bool,
};

const defaultProps = {
  className: '',
  dispatch: null,
  nfData: null,
  label: '',
  vertical: false,
};

class TrackingNFEmailTracking extends Component {
    _emailTracking = () => {
      const {
        dispatch,
        nfData: {
          id, nf, nfGroup, cnpjEmit, cnpjDest, following,
        },
      } = this.props;

      if (following) {
        dispatch(removeNFEmailTracking(id, nf, nfGroup, cnpjEmit, cnpjDest)).then(
          () => {},
          // reject
          error => console.log(error.message),
        );
      } else {
        dispatch(addNFEmailTracking(id, nf, nfGroup, cnpjEmit, cnpjDest)).then(
          () => {},
          // reject
          error => console.log(error.message),
        );
      }
    }

    render() {
      const {
        className, nfData: { following }, label, vertical, icon,
      } = this.props;

      return (
        <div className={`TrackingNFEmailTracking ' ${(className || '')}`}>
          <Toggle
            label={label}
            iconName={icon}
            vertical={vertical}
            isChecked={following}
            onChange={this._emailTracking}
            small
          />
        </div>
      );
    }
}

TrackingNFEmailTracking.propTypes = propTypes;
TrackingNFEmailTracking.defaultProps = defaultProps;

export default connect()(TrackingNFEmailTracking);
